import {Lifetime} from "../Lifetime";

export function delay(millis: number): Promise<void> {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve();
        }, millis);
    });
}

export function delayed(millis: number, lifetime: Lifetime, callback: () => void) {
    const timeout = window.setTimeout(callback, millis);
    lifetime.onTermination(() => window.clearTimeout(timeout));
}
